/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'

import { formatDate, ROUTES } from '../../shared/constants'
import { useHistory } from 'react-router'
import CustomTableLayout from '../../components/CustomComponents/CustomTableLayout'
import { useDownload } from '../../hooks/Download/useDownload'
import { CompanyConfigContext } from '../../context api/Configuration/CompanyConfig'
import { usePermissions } from '../../hooks/Authentication/usePermissions'

export default function Permissions() {
  const { getAllPermissions, deleteManyPermission, loading, paginate, updatePermission } = usePermissions()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { permissions } = useContext(CompanyConfigContext)
  console.log({ permissions })
  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterPermission = permissions ? permissions : []
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllPermissions({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_PERMISSIONS')
  }, [])

  const handleChange = (event, value) => {
    setPage(value)
    console.log("hello")

  }

  const tempHeaders = [{ label: 'permissionCode' }, { label: 'name' }]

  const handleSwitchChange = (item) => updatePermission({ ...item, active: !item.active, permissionId: item._id })

  let tableBody = []

  if (!loading && filterPermission.length > 0) {
    tableBody = filterPermission.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { value: item.permissionCode },
        { value: item.name },
        { value: formatDate(item.createdAt) },
        { type: 'STATUS', ...item },
        { type: 'INFO', onClick: () => history.push(`/view-permission/${item._id}`) },
      ]
    })
  }

  const layoutProps = {
    heading: 'Manage Permissions',
    url: ROUTES.ADD_PERMISSION,
    editUrl: `/edit-permission/`,
    permissionName: "MASTERS",
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaders: tempHeaders,
    tempHeaderData: [],
    filename: 'permissions',
    sheetName: 'permission',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
  }

  return (
    <CustomTableLayout
      tableHeadings={['Permission Code', 'Name', 'Created At', 'Status', 'Info']}
      loading={loading}
      tableBody={tableBody}
      handleSwitchChange={handleSwitchChange}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => deleteManyPermission({ permissionId: val }, setSelected)}
    />
  )
}
